module.exports = __webpack_public_path__ + "static/media/as-chosen.2a81f435.png";